import { css } from '@emotion/react'
import { HFlow, Text, VFlow } from 'bold-ui'
import { useClock } from 'hooks/useClock'
import logoImgBlue from 'images/esus.svg'
import logoImgWhite from 'images/esus_white.svg'

interface HeaderPainelChamadaProps {
  nomeUnidadeSaude?: string
  variant?: 'light' | 'dark'
}

export function HeaderPainelChamada({ nomeUnidadeSaude, variant = 'dark' }: Readonly<HeaderPainelChamadaProps>) {
  const horarioAtual = useClock()

  const logoSrc = variant === 'light' ? logoImgBlue : logoImgWhite

  return (
    <HFlow justifyContent='space-between'>
      <img css={styles.image} src={logoSrc} alt='Logo e-SUS Atenção Primária' />
      <VFlow vSpacing={0} style={styles.textAlignRight}>
        {nomeUnidadeSaude && (
          <Text color='inherit' variant='h1'>
            {nomeUnidadeSaude}
          </Text>
        )}
        <Text color='inherit' style={styles.clockText}>
          {horarioAtual}
        </Text>
      </VFlow>
    </HFlow>
  )
}

const styles = {
  image: css`
    height: 2rem;
  `,
  textAlignRight: css`
    text-align: right;
  `,
  clockText: css`
    font-size: 2.5rem;
    line-height: 1;
  `,
}
